import React from 'react';

import { Button, FormCheck, Table } from 'react-bootstrap-5';
import { formatWithCommas, USD } from '../../../../helpers/formatters/number_formats';
import { PROPERTY_MODEL } from '../../constants';
import ConnectTagManager from '../tags/connect_tag_manager';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTag } from '@fortawesome/pro-solid-svg-icons';
import { setOffMarketPropertyId } from 'bundles/connect/components/store/actions/off_market_property';
import { connect } from 'react-redux';
import type { ConnectProperty } from 'bundles/connect/types';

type Props = {
  properties: ConnectProperty[];
  selectedProperties: ConnectProperty[];
  onSelect: (property: ConnectProperty) => void;
  onSelectAll: () => void;
  setOffMarketPropertyId: (id: string) => void;
}

function MyPropertiesTable({ properties, selectedProperties, onSelect, onSelectAll, setOffMarketPropertyId }: Props) {
  return (
    <Table bordered className="my-0" responsive style={{ minWidth: '800px' }}>
      <thead className="bg-light">
        <tr className="align-middle">
          <th>
            <div className="d-flex gap-3">
              <FormCheck
                checked={selectedProperties.length === properties.length}
                width={24}
                onChange={() => onSelectAll()}
              />
              <div>Address</div>
            </div>
          </th>
          <th>Property Type</th>
          <th>SF</th>
          <th>Price</th>
          <th>Tags</th>
        </tr>
      </thead>
      <tbody>
        {properties.map((property => (
          <tr className="align-middle hover-toggle-parent" key={property.propertyId || property.insightsPropertyId}>
            <td>
              <div className="d-flex gap-3">
                <FormCheck
                  checked={
                    selectedProperties.some(selectedProperty => selectedProperty.propertyId === property.propertyId)
                  }
                  onChange={() => onSelect(property)}
                />
                <div style={{ lineHeight: '1.25' }}>
                  <Button
                    className="fw-bolder p-0"
                    variant="link"
                    onClick={() => setOffMarketPropertyId(property.propertyId || property.insightsPropertyId)}
                  >
                    {property.address}
                  </Button>
                  <div className="text-muted">
                    <small>{property.city}, {property.state}</small>
                  </div>
                </div>
              </div>
            </td>
            <td className="text-muted">{property.propertyType}</td>
            <td className="text-muted">{property.buildingSizeSf && formatWithCommas(property.buildingSizeSf)}</td>
            <td className="text-muted">
              {
                (property.lastSalePrice !== null && property.lastSalePrice !== 0)
                && USD.format(property.lastSalePrice, { round: true })
              }
            </td>
            <td style={{ width: '300px' }}>
              <ConnectTagManager
                buttonProperties={{
                  buttonClasses: 'hover-d-inline',
                  variant: 'text-primary',
                  iconLeft: <FontAwesomeIcon className="me-2" icon={faTag} />
                }}
                initialTags={property.tags}
                recordId={property.id}
                recordType={PROPERTY_MODEL}
              />
            </td>
          </tr>
        )))}
      </tbody>
    </Table>
  );
}

export default connect(undefined, { setOffMarketPropertyId })(MyPropertiesTable);
